import React, { useState, useEffect, } from "react";
import Modal from '@mui/material/Modal';
// import Box from '@mui/material/Box';
// import { Button } from '../components/ui/button';
import Tooltip from '@mui/material/Tooltip';
import { DataGrid } from '@mui/x-data-grid';
import ConfirmDialog from "../ConfirmDialog";
import ModalContainer from "./ModalContainer";

import {
  Modal as ModalNewOrder,
  Box,
  Typography,
  TextField,
  Autocomplete,
  Button,
  IconButton,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Switch,
  ListItemText, ListItem
} from '@mui/material';
import { toast } from 'react-toastify';

import { Edit, Trash } from 'lucide-react';

import { Formik, Field, Form, FormikConsumer, useFormik } from 'formik';
import * as Yup from 'yup';

import { format, parseISO } from "date-fns"; // Importamos date-fns
import { es } from "date-fns/locale"; // Español

import inboundService from "../../services/InboundService";
import TransportistasService from "../../services/TransportistasService";
import RemolquesService from "../../services/RemolquesService";

import { useSelector, useDispatch } from "react-redux";
import { setAllInboundContenedores, setAllInbound } from "../../redux/slice/InboundSlice";
import SimpleMessageDialog from "./../SimpleMessageDialog";

const InboundNewModal = ({
  isOpen, onClose,
  // onSubmit, 
  formData, setFormData, setModalIsOpen, setInboundData, isEditInbound, embarqueSelected, updateShipmentInboundParent }) => {


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  const [lineaTransporte, setLineaTransporte] = useState([]);
  const [requerimientos, setRequerimientos] = useState([]);
  const [operadores, setOperadores] = useState([]);
  const [vehiculos, setVehiculos] = useState([]);

  const [contenedores, setContenedores] = useState([]);
  const [contenedoresSinAsignar, setContenedoresSinAsignar] = useState([]);

  const [remolques, setRemolques] = useState([]);
  const [contenedorSelected, setContenedorSelected] = useState(null);
  const [cuentas, setCuentas] = useState([]);
  const [filterCuentaSelected, setFilterCuentaSelected] = useState();

  let allContenedores = useSelector((state) => state.inbound.allContenedores);
  const dispatch = useDispatch(); // Usar acciones


  const [openModalContainer, setOpenModalContainer] = useState(false);
  const handleOpenModalContainer = () => setOpenModalContainer(true);
  const handleCloseModalContainer = () => {
    setOpenModalContainer(false);
    setisEditContenedor(false);

  }

  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalWarning, setOpenModalWarning] = useState(false);


  const [openHidden, setOpenHidden] = useState(false);
  const [isEditContenedor, setisEditContenedor] = useState(false);

  const [filteredContenedores, setFilteredContenedores] = useState([]);
  const [filtroActivado, setFiltroActivado] = useState(false);


  const handleHidden = () => setOpenHidden(prev => !prev);

  const [sortModel, setSortModel] = useState([
    { field: "created_at", sort: "desc" }, // Orden predeterminado
  ]);

  if (isEditInbound) {
    // En modo edición, eliminamos el orden
    sortModel.length = 0; // Reseteamos el modelo de orden
  }

  const handleCheckboxChange = (id, values) => {

    const selectedRow = allContenedores.find((row) => row.id_contenedor === id);

    for (let key in selectedRow) {
      if (selectedRow[key] === null || selectedRow[key] === undefined) {
        setOpenModalWarning(true)
        return;
      }
    }


    const isAlreadySelected = values.contenedores.some((row) => row.id_contenedor === id);

    if (isAlreadySelected) {
      // Si ya está seleccionado, lo eliminamos
      const updatedSelection = values.contenedores.filter((row) => row.id_contenedor !== id);
      formikEmbarque.setFieldValue("contenedores", updatedSelection);
    } else if (values.contenedores.length < 2) {
      // Si no está seleccionado y hay espacio, lo agregamos
      if (!selectedRow) return;

      if (values.contenedores.length === 1) {
        const existingType = values.contenedores[0].nombre_cuenta;
        if (selectedRow.nombre_cuenta !== existingType) {
          return;
        }
      }

      formikEmbarque.setFieldValue("contenedores", [...values.contenedores, { ...selectedRow, checked: true }]);
      // console.log(values);

    }
  };

  const isChecked = (values, params) => {
    return values.contenedores.some(row => row.id_contenedor === params.row.id_contenedor);
  };

  const canDisabledEditContainer = () => {
    if (isEditInbound === true && embarqueSelected.id_status_of_inbound > 1) {
      return true;
    }
    return false;
  };



  const columns = [
    {
      field: "checked",
      headerName: "Selecciona",
      width: 130,
      align: "left",
      renderCell: (params) => (

        <Checkbox
          checked={isChecked(formikEmbarque.values, params)}
          onChange={() => handleCheckboxChange(params.row.id_contenedor, formikEmbarque.values)}
        />
      ),
    },
    { field: 'nombre_cuenta', headerName: 'Cuenta', width: 130, align: 'left' },
    { field: 'pedimento', headerName: 'Pedimento', width: 130, align: 'left' },
    { field: 'folio', headerName: 'Folio', width: 130, align: 'left' },
    { field: 'contenedor', headerName: 'Contenedor', width: 130, align: 'left' },
    { field: 'cantidad', headerName: 'Cantidad', type: 'number', width: 130, align: 'right' },
    { field: 'nombre_origen', headerName: 'Origen', width: 130, align: 'right' },
    { field: 'nombre_naviera', headerName: 'Naviera', width: 130, align: 'right' },
    { field: 'nombre_bodega', headerName: 'Bodega', width: 130, align: 'left', },
    { field: 'nombre_puerta_vacio', headerName: 'Puerta Vacio', width: 130, align: 'right' },
    {
      field: 'hora_de_cita', headerName: 'Hora de cita', width: 160, align: 'left',
      valueFormatter: (params) => {
        if (params) {

          const dateFormated = format(parseISO(params), "dd/MM/yyyy HH:mm:ss", { locale: es })

          return dateFormated;
        } else {
          return "";
        }

      }

    },
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 200,
      renderCell: (params) => (
        <>

          <Button variant="destructive" onClick={() => handleEditContenedor(params.row)} disabled={canDisabledEditContainer()} className={`${canDisabledEditContainer() ? "opacity-50 cursor-not-allowed" : ""}`}>
            <Tooltip title="Editar">

              <Edit className="w-4 h-4" />
            </Tooltip>

          </Button>
          <Button variant="destructive" onClick={() => handleDeleteContenedor(params.row)} disabled={canDisabledEditContainer()} className={`${canDisabledEditContainer() ? "opacity-50 cursor-not-allowed" : ""}`}  >

            <Tooltip title="Borrar">

              <Trash className="w-4 h-4" />
            </Tooltip>

          </Button>
        </>
      ),
    },
    { field: "created_at" }
  ];



  const validarContenedoresParaRemolques = (value, context) => {
    const { contenedores, checked2Remolque } = context.parent;
    if (checked2Remolque && (!contenedores || contenedores.length < 2)) {
      return false; // No pasa la validación si hay menos de 2 contenedores
    }
    return true;
  };


  const validator2Contenedores2Remolques = (value, context) => {
    const { contenedores, remolque2 } = context.parent;

    if (contenedores.length === 2 && !value) {
      return false; // Si hay 2 contenedores y remolque1 no está seleccionado, fallo la validación
    }

    // Si hay 2 contenedores y no se ha seleccionado remolque2, también fallamos la validación
    if (contenedores.length === 2 && !remolque2) {
      return false;
    }

    return true;
  };



  const formikEmbarque = useFormik({
    initialValues: {
      cuenta: null,
      contenedores: [],
      fecha_de_carga: "",
      linea_de_transporte: null,
      operador: null,
      vehiculo: null,
      remolque1: null,
      checked2Remolque: false,
      remolque2: null,
      requerimientos_adicionales: []

    },
    validationSchema: Yup.object({
      cuenta: Yup.mixed().required("*requerido"),
      contenedores: Yup.array()
        .min(1, "*Selecciona al menos 1 contenedor")
        .when("checked2Remolque", {
          is: true,
          then: (schema) => schema.min(2, "*Si seleccionas 2 remolques, debes agregar 2 contenedores"),
        })
        .required("*requerido"),
      fecha_de_carga: Yup.string().required("*requerido"),
      linea_de_transporte: Yup.mixed().required("*requerido"),
      operador: Yup.mixed().required("*requerido"),
      vehiculo: Yup.mixed().required("*requerido"),
      checked2Remolque: Yup.boolean(),
      remolque1: Yup.object()
        .required("*requerido")
        .test(
          "remolques-requeridos",
          "*Si seleccionas 2 contenedores, debes agregar 2 remolques",
          validator2Contenedores2Remolques
        ),
      remolque2: Yup.object()
        .when("checked2Remolque", {
          is: true,
          then: (schema) =>
            schema
              .required("*requerido")
              .test(
                "validacion-remolque-contenedores",
                "*Si seleccionas 2 remolques, debes agregar al menos 2 contenedores",
                validarContenedoresParaRemolques
              ),
          otherwise: (schema) => schema.notRequired(),
        }),
      requerimientos_adicionales: Yup.array()
        .min(1, "*Debe contener al menos un elemento")
        .required("*requerido"),
    }),
    onSubmit: (values, { resetForm }) => {
      handleFormSubmitEmbarque(values, resetForm)
    },
  });




  const handleEditContenedor = (row) => {
    setOpenModalContainer(true);
    setContenedorSelected(row);
    setisEditContenedor(true);
  };

  // Función para manejar la eliminación de una fila
  const handleDeleteContenedor = async (row) => {
    setOpenModalDelete(true);
    setContenedorSelected(row);
  };


  const handleConfirmDeleteContenedor = async () => {
    setOpenModalDelete(false);

    if (contenedorSelected) {
      const responseDeleteContenedor = await inboundService.deleteContenedor(contenedorSelected.id_contenedor);
      if (responseDeleteContenedor.data && responseDeleteContenedor.data.status == 200) {
        toast.success('Registro eliminado exitosamente');
        // const arrayItemDelete = contenedoresSinAsignar.filter(item => item.id_contenedor != contenedorSelected.id_contenedor);

        // setContenedoresSinAsignar(arrayItemDelete);

        let valueFormikBefore = formikEmbarque.values.contenedores;
        const formikContenedorDeleted = valueFormikBefore.filter(item => item.id_contenedor != contenedorSelected.id_contenedor);
        formikEmbarque.setFieldValue("contenedores", formikContenedorDeleted)

        // updateShipmentInboundParent()

        // const arrayItemDeleteAll = contenedores.filter(item => item.id_contenedor != contenedorSelected.id_contenedor);
        // setContenedores(arrayItemDeleteAll);
      } else {
        toast.error('Hubo un error en la operacion');
      }

    }

    setContenedorSelected(null);
    console.log(contenedorSelected);

    // console.log('delete Row:', row); // Aquí puedes implementar un modal de edición
  };





  const handleLineaChange = async (value) => {
    // console.log(value);
    formikEmbarque.setFieldValue("linea_de_transporte", value)

    // setSelectedLineaTransporte(value); // Actualiza el cliente seleccionado

    if (value !== null) {
      formikEmbarque.setFieldValue("operador", null)
      formikEmbarque.setFieldValue("vehiculo", null)
      formikEmbarque.setFieldValue("remolque1", null)

      const operadores = await TransportistasService.getLineaTransporteConductores(value.id);

      if (operadores.status != 200) {
        throw new Error('Error al obtener los datos');
      }
      const data = await operadores.data;
      setOperadores(data)

      const vehiculos = await TransportistasService.getLineaTransporteVehiculos(value.id);
      if (vehiculos.status != 200) {
        throw new Error('Error al obtener los datos');
      }
      const data2 = await vehiculos.data;
      const onlyTraco = data2.filter(vehiculo => vehiculo.tipo === "TRACTO")
      setVehiculos(onlyTraco)

      const remloques = await RemolquesService.getRemolques(value.id);
      if (remloques.status != 200) {
        throw new Error('Error al obtener los datos');
      }
      const data3 = await remloques.data;
      setRemolques(data3)

    } else {

      setOperadores([]);
      setVehiculos([]);
      setRemolques([]);

      formikEmbarque.setFieldValue("operador", null)
      formikEmbarque.setFieldValue("vehiculo", null)
      formikEmbarque.setFieldValue("remolque1", null)
    }
  };



  const handleRemolqueChange = async (value) => {
    // console.log(value);
    formikEmbarque.setFieldValue("remolque1", value);



    if (value !== null) {
      formikEmbarque.setFieldValue("remolque2", null);

    } else {

      formikEmbarque.setFieldValue("remolque2", null);
    }
  };

  // embarqueSelected&&embarqueSelected.id_status_of_inbound>2

  const blockButton = (value) => {
    if (value && value.id_status_of_inbound > 1 && isEditInbound === true) {
      return true;
    }

    return false;

  };

  const handleChangeCuentaSelected = (value) => {


    if (value === null) {
      setFiltroActivado(false);  // Si el valor es null, desactivamos el filtro
      // setFilterCuentaSelected(null);  // Limpiamos el valor seleccionado
      formikEmbarque.setFieldValue("cuenta", null)
    } else {
      setFiltroActivado(true);  // Activar el filtro si se selecciona un valor
      formikEmbarque.setFieldValue("cuenta", value)

      let newContenedores = formikEmbarque.values.contenedores.filter(contenedor => contenedor.nombre_cuenta == value.nombre_cuenta)
      formikEmbarque.setFieldValue("contenedores", newContenedores);
      // setFilterCuentaSelected(value);  // Guardar la cuenta seleccionada
    }
  };

  const contenedoresMostrados = filtroActivado
    ? allContenedores.filter(c => c.nombre_cuenta === formikEmbarque.values.cuenta.nombre_cuenta) // Filtrar si está activado
    : allContenedores;  // Mostrar todo si no está activado





  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseCuentas = await TransportistasService.getCuentas();

        if (responseCuentas.status == 200 && responseCuentas.data) {
          setCuentas(responseCuentas.data)
        }

        const response3 = await TransportistasService.getLineasTransporte();
        if (response3.status != 200) {
          throw new Error('Error al obtener los datos');
        }
        const data3 = await response3.data;
        const onlyLineaActive = data3.filter(linea => linea.active === true)

        setLineaTransporte(onlyLineaActive)


        const response4 = await TransportistasService.getRequerimientos();
        if (response4.status != 200) {
          throw new Error('Error al obtener los datos');
        }
        const data4 = await response4.data;

        setRequerimientos(data4)

        // chargeContenedores();


      } catch (error) {
        console.error('Error:', error);
        toast.error('Error al cargar los datos');
      }
    };

    fetchData();
  }, []);


  const chargeToShowModalUpdate = async () => {
    const operadores = await TransportistasService.getLineaTransporteConductores(embarqueSelected.id_linea_transporte);
    // fetch(`${process.env.REACT_APP_API_URL}/api/v1/lineas_transporte/${embarqueSelected.id_linea_transporte}/conductores`);
    if (operadores.status != 200) {
      throw new Error('Error al obtener los datos');
    }
    const dataOperadores = await operadores.data;
    setOperadores(dataOperadores)

    const vehiculos = await TransportistasService.getLineaTransporteVehiculos(embarqueSelected.id_linea_transporte);
    // fetch(`${process.env.REACT_APP_API_URL}/api/v1/lineas_transporte/${embarqueSelected.id_linea_transporte}/vehiculos`);
    if (vehiculos.status != 200) {
      throw new Error('Error al obtener los datos');
    }
    const dataVehiculos = await vehiculos.data;
    const onlyTraco = dataVehiculos.filter(vehiculo => vehiculo.tipo === "TRACTO")
    setVehiculos(onlyTraco)

    const remloques = await RemolquesService.getRemolques(embarqueSelected.id_linea_transporte);
    // fetch(`${process.env.REACT_APP_API_URL}/api/v1/lineas-transporte/${embarqueSelected.id_linea_transporte}/remolques`);
    if (remloques.status != 200) {
      throw new Error('Error al obtener los datos');
    }
    const dataRemolques = await remloques.data;
    setRemolques(dataRemolques)

    const getCuenta = cuentas.find(cuenta => cuenta.id === embarqueSelected.id_cuenta);
    formikEmbarque.setFieldValue("cuenta", getCuenta);

    setFiltroActivado(true);

    formikEmbarque.setFieldValue("fecha_de_carga", embarqueSelected.fecha_de_carga);

    const getLineaTransporte = lineaTransporte.find(linea => linea.id === embarqueSelected.id_linea_transporte);

    formikEmbarque.setFieldValue("linea_de_transporte", getLineaTransporte);

    const getOperador = dataOperadores.find(operador => operador.id === embarqueSelected.id_operador);
    formikEmbarque.setFieldValue("operador", getOperador);

    const getVehiculo = onlyTraco.find(tracto => tracto.id === embarqueSelected.id_vehiculo);
    formikEmbarque.setFieldValue("vehiculo", getVehiculo);

    const getRemolque1 = dataRemolques.find(remolque => remolque.id === embarqueSelected.id_remolque1);
    formikEmbarque.setFieldValue("remolque1", getRemolque1);

    if (embarqueSelected.id_remolque2) {
      formikEmbarque.setFieldValue("checked2Remolque", true);
      const getRemolque2 = dataRemolques.find(remolque => remolque.id === embarqueSelected.id_remolque2);
      formikEmbarque.setFieldValue("remolque2", getRemolque2);
    }

    const getRequerimientos = JSON.parse(embarqueSelected.requerimientos_adicionales);
    formikEmbarque.setFieldValue("requerimientos_adicionales", getRequerimientos);


    formikEmbarque.setFieldValue("contenedores", embarqueSelected.contenedores);

    //   setContenedoresSinAsignar(prev => {
    //     const nuevos = embarqueSelected.contenedores.filter(c => !prev.some(p => p.id_contenedor === c.id_contenedor));
    //     return [ ...nuevos, ...prev,];
    // });

    dispatch((dispatch, getState) => {
      const currentAllContenedores = getState().inbound.allContenedores;

      // Filtramos los nuevos contenedores que no están en el estado actual
      const nuevos = embarqueSelected.contenedores.filter(
        (c) => !currentAllContenedores.some((p) => p.id_contenedor === c.id_contenedor)
      );

      // Fusionamos los nuevos contenedores con los existentes
      const updatedContenedores = [...nuevos, ...currentAllContenedores];

      // Despachamos la acción con el array actualizado
      dispatch(setAllInboundContenedores(updatedContenedores));
    });


  }

  useEffect(() => {
    if (isEditInbound) {
      chargeToShowModalUpdate();
    }
  }, [isEditInbound, embarqueSelected]);


  const handleFormSubmitEmbarque = async (values, resetForm) => {

    const onlyContainerID = values.contenedores.map(item => item.id_contenedor);
    let bodyShipment = {
      id_cuenta: values.cuenta.id,
      fecha_de_carga: values.fecha_de_carga,
      id_linea_transporte: values.linea_de_transporte.id,
      id_operador: values.operador.id,
      id_vehiculo: values.vehiculo.id,
      requerimientos_adicionales: JSON.stringify(values.requerimientos_adicionales),
      contenedores: onlyContainerID,
      remolques: [values.remolque1.id]
    }

    if (values.checked2Remolque === true) {
      bodyShipment.remolques.push(values.remolque2.id)
    }


    try {

      if (isEditInbound == true) {
        console.log("editado", embarqueSelected.id, bodyShipment);


        const responseUpdate = await inboundService.updateEmbarque(embarqueSelected.id, bodyShipment)
        if (responseUpdate.data && responseUpdate.data.status == 200) {
          toast.success("¡Operación exitosa!");
          setModalIsOpen(false);
          dispatch((dispatch, getState) => {
            const currentAllContenedores = getState().inbound.allContenedores;

            // Elimina los contenedores agregados en este modal
            const updatedContenedores = currentAllContenedores.filter(
              (c) => !formikEmbarque.values.contenedores.some((p) => p.id_contenedor === c.id_contenedor)
            );

            dispatch(setAllInboundContenedores(updatedContenedores));
          });
          setFiltroActivado(false);
          formikEmbarque.resetForm();
          console.log("editado");

        }
        return

      }

      const response = await inboundService.postCreateShipment(bodyShipment);

      if (response.status === 200) { // Verifica si el servidor devuelve 200
        toast.success("¡Operación exitosa!");
        const responseShiptments = await inboundService.getShipments();
        if (responseShiptments.status != 200) {
          throw new Error('Error al obtener los datos');
        }
        const data = await responseShiptments.data;
        setInboundData(data);
        setModalIsOpen(false);
        // chargeContenedores();
        resetForm();
        setFiltroActivado(false)
      } else {
        console.error(`Error: El servidor respondió con estado ${response.status}`);
        toast.error("Hubo un error");
      }

    } catch (error) {
      console.error('Error:', error);
      toast.error("Hubo un error");
    }



  };

  const hanldeClosePrincipal = () => {


    onClose();
    setFiltroActivado(false);

    if (isEditInbound == true) {

    dispatch((dispatch, getState) => {
      const currentAllContenedores = getState().inbound.allContenedores;

      // Elimina los contenedores agregados en este modal
      const updatedContenedores = currentAllContenedores.filter(
        (c) => !embarqueSelected.contenedores.some((p) => p.id_contenedor === c.id_contenedor)
      );

      dispatch(setAllInboundContenedores(updatedContenedores));
    });
    }

    formikEmbarque.resetForm()


  };


  // const chargeContenedores = async () => {

  //   const responseContenedores = await inboundService.getContenedores();
  //   if (responseContenedores.status!=200) {
  //     throw new Error('Error al obtener los datos');
  //   }
  //   const data = await responseContenedores.data;
  //   const newdata = data.map(item => ({
  //     ...item,
  //     checked: false,  // Agregamos la nueva propiedad
  //   }))
  //   const contenedoresSinAsignar = newdata.filter(c => c.estatus === "sin asignar");


  //   setContenedoresSinAsignar(contenedoresSinAsignar)
  //   setContenedores(newdata);
  // }

  const updateContenedores = async () => {

    const responseContenedores = await inboundService.getContenedores();
    if (responseContenedores.status != 200) {
      throw new Error('Error al obtener los datos');
    }


    const data = await responseContenedores.data;
    const newdata = data.map(item => ({
      ...item,
      checked: false,  // Agregamos la nueva propiedad
    }))
    const newContenedoresSinAsignar = newdata.filter(c => c.estatus === "sin asignar");
    // Filtrar solo los elementos que no están en arrayOriginal
    const nuevosElementos = newContenedoresSinAsignar.filter(nuevo =>
      !contenedoresSinAsignar.some(original => original.id_contenedor === nuevo.id_contenedor)
    );

    const arrayActualizado = [...nuevosElementos, ...contenedoresSinAsignar];
    setContenedoresSinAsignar(arrayActualizado)

  }

  const updateContenedoresWhenUpdate1Contenedor = async () => {
    try {

      dispatch((dispatch, getState) => {
        const currentAllContenedores = getState().inbound.allContenedores;

        const updatedContenedores = formikEmbarque.values.contenedores.map(original => {

          const existente = currentAllContenedores.find(nuevo => nuevo.id_contenedor === original.id_contenedor);
          return existente ? { ...original, ...existente } : original;
        });

        formikEmbarque.setFieldValue("contenedores", updatedContenedores)

      });


    } catch (error) {
      console.error("Error al actualizar los contenedores:", error);
    }
  };






  return (
    <>

      <Modal open={isOpen} onClose={hanldeClosePrincipal}>


        <Box className={`bg-white p-6 rounded-lg shadow-lg w-1/2 mx-auto max-h-[80%]  overflow-y-auto mt-20 `}>
          <form onSubmit={formikEmbarque.handleSubmit}>



            <h2 className="text-xl font-bold mb-4">{isEditInbound === false ? "Crear Nuevo Embarque" : "Editar Embarque"}</h2>
            <div className="my-4 pr-4 w-1/2">
              <Autocomplete
                value={formikEmbarque.values?.cuenta}
                onChange={(event, newValue) => handleChangeCuentaSelected(newValue)}
                getOptionLabel={(option) => option.nombre_cuenta}
                options={cuentas}
                renderInput={(params) => <TextField {...params} label="Selecciona una cuenta"
                  error={Boolean(formikEmbarque.errors.cuenta && formikEmbarque.touched.cuenta)} // Verifica si hay un error y si el campo fue tocado
                  helperText={formikEmbarque.touched.cuenta && formikEmbarque.errors.cuenta}
                />}
              />
              {/* <Autocomplete
                  fullWidth
                  options={lineaTransporte}
                  getOptionLabel={(option) => option.name}
                  onChange={(event, value) => handleLineaChange(value)}
                  value={formikEmbarque.values.linea_de_transporte}
                  renderInput={(params) => <TextField {...params} label="Linea de transporte *"
                    error={Boolean(formikEmbarque.errors.linea_de_transporte && formikEmbarque.touched.linea_de_transporte)} // Verifica si hay un error y si el campo fue tocado
                    helperText={formikEmbarque.touched.linea_de_transporte && formikEmbarque.errors.linea_de_transporte}
                  />}
                /> */}
            </div>


            <div className="flex  flex-row">
              <Button onClick={handleHidden} variant="contained" color="primary">
                {openHidden ? 'Ocultar Contenedores Disponibles' : 'Mostrar Contenedores Disponibles'}
              </Button>
              <button onClick={handleOpenModalContainer} type="button" className="bg-blue-500 ml-3 text-white px-4 py-2 rounded">Crear contenedor</button>
            </div>

            <Collapse in={openHidden}>
              <Box sx={{ width: "100%", }}>



                <DataGrid
                  rows={contenedoresMostrados}
                  columns={columns}
                  getRowId={(row) => row.id_contenedor}
                  sortModel={sortModel}
                  onSortModelChange={(model) => setSortModel(model)}
                  initialState={{
                    columns: {
                      columnVisibilityModel: {
                        created_at: false, // 👈 FORZA a que la columna esté oculta
                      },
                    },
                  }}
                  pagination={false}
                  pageSizeOptions={[]}
                  sx={{
                    border: 0,
                    height: 230,
                    '& .MuiDataGrid-columnHeaders': {
                      position: 'sticky',
                      top: 0,
                      zIndex: 1,
                      backgroundColor: 'white',
                    },
                  }}
                  hideFooter
                />

              </Box>
            </Collapse>

            <h2 className="text-md font-bold mb-4 mt-2">Contenedores seleccionados</h2>

            {formikEmbarque.values.contenedores.length > 0 ? (
              <TableContainer component={Paper} style={{ maxHeight: "230px", overflowY: "auto", overflowX: "auto" }}>
                <Table style={{ tableLayout: "static", width: "100%" }}>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ width: "30%" }}>Cuenta</TableCell>
                      <TableCell style={{ width: "30%" }}>Pedimento</TableCell>
                      <TableCell style={{ width: "30%" }}>Folio</TableCell>
                      <TableCell style={{ width: "30%" }}>Contenedor</TableCell>
                      <TableCell style={{ width: "30%" }}>cantidad</TableCell>
                      <TableCell style={{ width: "30%" }}>Origen</TableCell>
                      <TableCell style={{ width: "30%" }}>Naviera</TableCell>
                      <TableCell style={{ width: "30%" }}>bodega</TableCell>
                      <TableCell style={{ width: "30%" }}>Puerta Vacio</TableCell>
                      <TableCell style={{ width: "30%" }}>Hora de cita</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {formikEmbarque.values.contenedores
                      .map((container) => (
                        <TableRow key={container.id_contenedor}>
                          <TableCell >{container.nombre_cuenta}</TableCell>
                          <TableCell >{container.pedimento}</TableCell>
                          <TableCell >{container.folio}</TableCell>
                          <TableCell >{container.contenedor}</TableCell>
                          <TableCell >{container.cantidad}</TableCell>
                          <TableCell >{container.nombre_origen}</TableCell>
                          <TableCell >{container.nombre_naviera}</TableCell>
                          <TableCell >{container.nombre_bodega}</TableCell>
                          <TableCell >{container.nombre_puerta_vacio}</TableCell>
                          <TableCell >{container.hora_de_cita && format(parseISO(container.hora_de_cita), "dd/MM/yyyy HH:mm:ss", { locale: es })}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <p style={{ color: "#666", fontSize: "14px" }}>No hay Contenedores Seleccionados</p>
            )}

            {formikEmbarque.touched.contenedores && formikEmbarque.errors.contenedores && (
              <div className="text-red-500 text-sm">{formikEmbarque.errors.contenedores}</div>
            )}


            <h2 className="text-md font-bold mb-4 mt-2">Fecha de carga</h2>
            <div className="flex">
              <div>
                <TextField
                  type="datetime-local"
                  name="fecha_de_carga"
                  fullWidth
                  variant="outlined"
                  value={formikEmbarque.values.fecha_de_carga}
                  onChange={(event, value) => {
                    formikEmbarque.setFieldValue("fecha_de_carga", event.target.value);
                  }}
                />
                {formikEmbarque.touched.fecha_de_carga && formikEmbarque.errors.fecha_de_carga && (
                  <div className="text-red-500 text-sm">{formikEmbarque.errors.fecha_de_carga}</div>
                )}
              </div>

            </div>

            <h2 className="text-md font-bold mb-4 mt-2">Transportista</h2>
            <div className="flex flex-wrap gap-2">
              <div className="w-[48%] ">

                <Autocomplete
                  fullWidth
                  options={lineaTransporte}
                  getOptionLabel={(option) => option.name}
                  onChange={(event, value) => handleLineaChange(value)}
                  value={formikEmbarque.values.linea_de_transporte}
                  renderInput={(params) => <TextField {...params} label="Linea de transporte *"
                    error={Boolean(formikEmbarque.errors.linea_de_transporte && formikEmbarque.touched.linea_de_transporte)} // Verifica si hay un error y si el campo fue tocado
                    helperText={formikEmbarque.touched.linea_de_transporte && formikEmbarque.errors.linea_de_transporte}
                  />}
                />

              </div>

              <div className="w-[48%] ">

                <Autocomplete
                  fullWidth
                  options={operadores}
                  getOptionLabel={(option) => `${option.nombre} ${option.apellido_paterno} ${option.apellido_materno}`}
                  onChange={(event, value) => {
                    formikEmbarque.setFieldValue("operador", value);
                  }}
                  value={formikEmbarque.values.operador}
                  renderInput={(params) => <TextField {...params} label="Operadores *"
                    error={Boolean(formikEmbarque.errors.operador && formikEmbarque.touched.operador)}
                    helperText={formikEmbarque.touched.operador && formikEmbarque.errors.operador}
                  />}
                />
              </div>

              <div className="w-[98%] mt-2">

                <Autocomplete
                  fullWidth
                  options={vehiculos}
                  getOptionLabel={(option) => `${option.placas} - ${option.tipo} `}
                  onChange={(event, value) => {
                    formikEmbarque.setFieldValue("vehiculo", value);
                  }}
                  value={formikEmbarque.values.vehiculo}
                  renderInput={(params) => <TextField {...params} label="Vehiculos *"
                    error={Boolean(formikEmbarque.errors.vehiculo && formikEmbarque.touched.vehiculo)}
                    helperText={formikEmbarque.touched.vehiculo && formikEmbarque.errors.vehiculo}
                  />}
                />
              </div>

              <div className="w-[48%] mt-2">

                <Autocomplete
                  fullWidth
                  options={remolques}
                  getOptionLabel={(option) => `${option.placas} - ${option.modelo} - ${option.economico}`}
                  onChange={(event, value) => handleRemolqueChange(value)}
                  value={formikEmbarque.values.remolque1}
                  renderInput={(params) => <TextField {...params} label="Remolque *"
                    error={Boolean(formikEmbarque.errors.remolque1 && formikEmbarque.touched.remolque1)}
                    helperText={formikEmbarque.touched.remolque1 && formikEmbarque.errors.remolque1}
                  />}
                />


              </div>

              <div className="w-[48%] flex">
                <Box display="flex" alignItems="center" gap={1}>
                  <Switch
                    checked={formikEmbarque.values.checked2Remolque}
                    onChange={(e, value) => {
                      const isChecked = e.target.checked;
                      formikEmbarque.setFieldValue("checked2Remolque", isChecked);
                      if (!isChecked || isChecked == false) {
                        formikEmbarque.setFieldValue("remolque2", null); // O null, dependiendo de cómo manejas la propiedad
                      }
                    }}
                    // onChange={(e) => setChecked2Remolque(e.target.checked)}
                    color="primary"
                  />
                  <Typography>FULL</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                    (Seleccionar si el embarque requiere doble remolque)
                  </Typography>
                </Box>
              </div>

              {
                formikEmbarque.values && formikEmbarque.values.checked2Remolque && formikEmbarque.values.checked2Remolque == true &&
                (
                  <div className="w-[48%] mt-2">

                    <Autocomplete
                      fullWidth
                      options={remolques.filter((r) => r.id !== formikEmbarque.values.remolque1?.id)}
                      getOptionLabel={(option) => `${option.placas} - ${option.modelo} - ${option.economico}`}
                      onChange={(event, value) => {
                        formikEmbarque.setFieldValue("remolque2", value);
                      }}
                      value={formikEmbarque.values.remolque2}
                      renderInput={(params) => <TextField {...params} label="Remolque *"
                        error={Boolean(formikEmbarque.errors.remolque2 && formikEmbarque.touched.remolque2)}
                        helperText={formikEmbarque.touched.remolque2 && formikEmbarque.errors.remolque2}
                      />}
                    />


                  </div>

                )
              }






            </div>


            <h2 className="text-md font-bold mb-4 mt-2">Requerimientos adicionales</h2>
            <div className="w-full ">

              <Autocomplete
                multiple
                options={[{ requerimiento: 'Seleccionar todos' }, ...requerimientos]} // Agregar opción "Seleccionar todos"
                getOptionLabel={(option) => option.requerimiento}
                isOptionEqualToValue={(option, value) => option.requerimiento === value.requerimiento}
                value={formikEmbarque.values.requerimientos_adicionales}
                onChange={(event, value) => {
                  // Si "Seleccionar todos" está seleccionado, añadir todos los requerimientos
                  if (value.some(item => item.requerimiento === 'Seleccionar todos')) {
                    formikEmbarque.setFieldValue("requerimientos_adicionales", requerimientos);
                  } else {
                    formikEmbarque.setFieldValue("requerimientos_adicionales", value);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Selecciona requerimientos"
                    placeholder="Escribe para buscar"
                    error={Boolean(formikEmbarque.errors.requerimientos_adicionales && formikEmbarque.touched.requerimientos_adicionales)}
                    helperText={formikEmbarque.touched.requerimientos_adicionales && formikEmbarque.errors.requerimientos_adicionales}
                  />
                )}
              />
            </div>


            {/* El botón ahora tiene el tipo 'submit' */}
            <div className="flex flex-row  justify-between items-end">
              <Button onClick={hanldeClosePrincipal} className="ml-2">Cancelar</Button>
              <button type="submit" className={`bg-blue-500 text-white px-4 py-2 rounded mt-2 ${blockButton(embarqueSelected) ? "opacity-50 cursor-not-allowed" : ""
                }`}
                disabled={blockButton(embarqueSelected) || formikEmbarque.isSubmitting}
              >{isEditInbound === false ? "Crear" : "Editar"}</button>

            </div>

          </form>
        </Box>



      </Modal>

      {/* modal 2 */}
      <ModalContainer
        openModalContainer={openModalContainer}
        onClose={() => handleCloseModalContainer()}
        updateContenedoresParent={() => updateContenedores()}
        isEditContenedor={isEditContenedor}
        setisEditContenedor={setisEditContenedor}
        contenedorSelected={contenedorSelected}
        updateContenedoresWhenUpdate1Contenedor={() => updateContenedoresWhenUpdate1Contenedor()}
      />

      <ConfirmDialog
        open={openModalDelete}
        onClose={() => setOpenModalDelete(false)}
        onConfirm={() => handleConfirmDeleteContenedor()}
        title="Eliminar Contenedor"
        message="¿Estás seguro de que quieres eliminar este registro? Esta acción no se puede deshacer."
        icon="warning"
      />

      <SimpleMessageDialog
        open={openModalWarning}
        onClose={() => setOpenModalWarning(false)}
        title="Aviso"
        message="No puedes seleccionar un contenedor incompleto. Editalo y llena los datos faltantes"
        icon="warning"
      />
    </>
  );
};

export default InboundNewModal;
